import * as yup from 'yup'
import { ERROR_MESSAGE } from 'utils/globalConstant'

export const validationSchema = yup.object({
    full_name: yup.string().required(ERROR_MESSAGE.required),
    email_address: yup.string().required(ERROR_MESSAGE.required),
})
